import { Sheet, SheetRef } from "react-modal-sheet";
import { useEffect, useRef } from "react";

import { CoverageDetails } from "./Coverages";
import PartnerDetails from "./PartnerDetails";
import { GrClose } from "react-icons/gr";
import { useApp } from "../../contexts/AppContext";

export function BottomSheet() {
  const { isPrivacyOpen, setIsPrivacyOpen, coverage } = useApp();
  const ref = useRef<SheetRef>();

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;


  const snapTo = (i: number) => ref.current?.snapTo(i);

  useEffect(() => {

    console.log("prefersReducedMotion:", prefersReducedMotion);
    console.log("isPrivacyOpen is: ", isPrivacyOpen);
    console.log("coverage is: ", coverage);
  }, [isPrivacyOpen, coverage]);

  return (
    <>
      <Sheet
        isOpen={isPrivacyOpen}
        onClose={() => setIsPrivacyOpen(false)}
        detent="content-height"
        disableDrag={prefersReducedMotion} // Disable drag if reduced motion is enabled
      >
        <Sheet.Container>
          <div
            className="close-button-container"
            style={{ textAlign: "right" }}
          >
            <button
              onClick={() => setIsPrivacyOpen(false)}
              className="close-button"
            >
              <GrClose />
            </button>
          </div>
          <Sheet.Header />
          <Sheet.Content>
            <Sheet.Scroller
              draggableAt={prefersReducedMotion ? undefined : "both"}
            >
              <div
                style={{
                  paddingLeft: 10,
                  paddingRight: 10,
                  height: "100vh",
                  overflowY: "auto",
                  transition: prefersReducedMotion ? "none" : "all 0.3s ease",
                }}
              >
                {/* Renderiza conteúdo com base no valor de `coverage` */}
                {coverage?.affiliateName ? (
                  <PartnerDetails />
                ) : (
                  <CoverageDetails />
                )}
              </div>
            </Sheet.Scroller>
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop />
      </Sheet>
    </>
  );
}
